import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Call(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Call", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36 33.4494c0 3.506-3.0476 6.4583-6.7619 6.5506C15.3333 40 4 29.0208 4 15.5506 4 11.9524 7.04762 9 10.7619 9c.4762 0 .8571 0 1.2381.09226.5714.09226 1.1429.27679 1.7143.55357L14 9.83036l1.7143 10.33334-.2857.2768c-.8572.7381-1.7143 1.2916-2.7619 1.4762 1.7143 4.4285 5.4285 8.0268 10 9.6875.2857-.9226.7619-1.8453 1.5238-2.6756l.2857-.2768 10.6667 1.6607.1904.2768c.2857.4613.4762 1.1071.5715 1.6607.0952.2768.0952.7381.0952 1.1994Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M34.5 32c4.6944 0 8.5-3.8056 8.5-8.5S39.1944 15 34.5 15 26 18.8056 26 23.5s3.8056 8.5 8.5 8.5Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.9048 25.3333c-.5429 0-.9048-.3619-.9048-.9047v-4.5238c0-.5429.3619-.9048.9048-.9048.5428 0 .9047.3619.9047.9048v4.5238c0 .5428-.3619.9047-.9047.9047Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.5238 25.333h-3.619c-.5429 0-.9048-.3619-.9048-.9048s.3619-.9048.9048-.9048h3.619c.5429 0 .9048.3619.9048.9048s-.3619.9048-.9048.9048Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Call.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Call"
};
validateTidalLicense();
export {
  Call
};
//# sourceMappingURL=Call.js.map
